import { MemberBankHttpService } from '@core/services/member-bank-http.service';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthRegister } from '@core/models/auth-register.model';
import { AuthHttpService } from '@core/services/auth-http.service';
import { BankHttpService } from '@core/services/bank-http.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { GameCategoryHttpService } from '@core/services/game-category-http.service';
import { MerchantBankHttpService } from '@core/services/merchant-bank-http.service';
import * as fromAuthActions from '@core/store/auth/auth.actions';
import { Store } from '@ngrx/store';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppState } from '@store/reducers';
import { of, Subscription, forkJoin } from 'rxjs';
import { delay, tap, map, catchError } from 'rxjs/operators';
import { LoginModalComponent } from './../login-modal/login-modal.component';
import { environment } from '@env/environment';
import { BankMaintenanceHourService } from '@core/services/bank-maintenance-hour.service';
//Recaptcha
import { ReCaptchaV3Service } from 'ng-recaptcha';
import svgIconList from 'assets/icons.json';

declare const $: any;
@Component({
  selector: 'app-signup-modal',
  templateUrl: './signup-modal.component.html',
  styleUrls: ['./signup-modal.component.scss']
})
export class SignupModalComponent implements OnInit {
  svg: any = svgIconList;

  @ViewChildren('focusInput') focusInput: QueryList<ElementRef>;
  messages$ = this.auth.messages$;
  form: FormGroup;
  passwordInput = {
    type: 'password',
    icon: this.svg.hidePasswordIcon
  };
  currentCountry = localStorage.getItem('country_code');

  confirmPasswordInput = {
    type: 'password',
    icon: this.svg.hidePasswordIcon
  };
  passwordMatched = true;
  disableButton = false;
  dropDownCountries = [];
  selected = "";
  css = "";
  checkValidity = false;
  ref = null;
  aff = null;
  agent = null;
  isRefSet = false;
  showRef = true;
  showAgent = false;
  showAff = false;
  usernameFormatValid = {
    consist: false,
    special: false
  };

  // recaptcha
  recaptchaScore = 0;

  // server side validationS
  enableServerSideValidation = true;
  serverSideValidated = false;
  serverSideValidations = { // true if valid, else false
    username: false,
  };

  supportedCountry = this.dropdownService.availableCountryAndLanguages;
  currentDomain = JSON.parse(sessionStorage.getItem('mainDomainBlocked')) ? this.getAltDomain() : environment.domainName;
  private subscription = new Subscription();
  constructor(
    private dropdownService: DropdownHttpService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SignupModalComponent>,
    private auth: AuthHttpService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    public loadingBar: LoadingBarService,
    public router: Router,
    private eventEmitterService: EventEmitterService,
    private gameCategoryHttpService: GameCategoryHttpService,
    private bankHttpService: BankHttpService,
    private merchantBankHttpService: MerchantBankHttpService,
    private memberBankHttpService: MemberBankHttpService,
    private bankMaintenanceHourService: BankMaintenanceHourService,
    private recaptchaV3Service: ReCaptchaV3Service,
  ) { }

  ngOnInit() {
    Object.keys(this.dropdownService.availableCountryAndLanguages[this.currentDomain]).forEach(key => {
      if (key != 'TH') {
        this.dropDownCountries.push({
          value: key
        });
      }
    })
    this.selected = localStorage.getItem('country_code') ? localStorage.getItem('country_code').toUpperCase() : '';
    this.setRefAgentAff();
    this.initializeForm();
    of(null).pipe(
      delay(1000), tap(() => this.focusInput.first.nativeElement.focus()
      )).subscribe();
    this.eventEmitterService.buttonEmitter.subscribe(() => {
      this.disableButton = false;
    });

    $(document).on('click', ".tnc-link", () => {
      window.history.replaceState({}, '', `/info-center?tab=${'termsconditions'}`);
      window.location.reload();
    });
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onLogin() {
    this.onCloseDialog();
    this.openDialogBy(LoginModalComponent);
  }

  resetServerValidation() {
    this.serverSideValidated = false;

    if (this.enableServerSideValidation) {
      this.serverSideValidations = {
        username: false,
      };
    }
  }

  onServerSideUsernameValidation(username: any) {
    if (!username) return;

    this.recaptchaV3Service
      .execute('ValidateUsername')
      .pipe(
        tap((token: any) => {
          // if token not available, disable server side validation
          if (!token) {
            this.enableServerSideValidation = false;
            return;
          }

          if (this.enableServerSideValidation) {
            this.auth.validate({ response: token, username }).subscribe(res => {
              this.serverSideValidated = true;
              const errorType = res.data?.rows?.error_type;
              this.serverSideValidations.username = (errorType == 0) || !(errorType == 1);
            });
          }
        }),
        catchError((err) => {
          this.enableServerSideValidation = false;
          this.serverSideValidations.username = true;
          return err;
        })
      ).subscribe();
  }

  onPasswordMask(type?: string) {
    if (type === 'password') {
      this.passwordInput.type = this.passwordInput.type === 'password' ? 'text' : 'password';
      this.passwordInput.icon = this.passwordInput.icon === this.svg.hidePasswordIcon ?this.svg.viewPasswordIcon : this.svg.hidePasswordIcon;
    } else {
      this.confirmPasswordInput.type = this.confirmPasswordInput.type === 'password' ? 'text' : 'password';
      this.confirmPasswordInput.icon = this.confirmPasswordInput.icon === this.svg.hidePasswordIcon ?this.svg.viewPasswordIcon : this.svg.hidePasswordIcon;
    }
  }

  onCheckPassword() {
    this.passwordMatched = true;
    if (this.form.value.confirm_password !== null && this.form.value.password !== null) {
      if (this.form.value.password !== this.form.value.confirm_password) {
        this.passwordMatched = false;
      }

      if (this.form.value.password.length === 0 || this.form.value.confirm_password.length === 0) {
        this.passwordMatched = true;
      }
    }
  }

  onChangeCountry(countryCode: string) {
    this.currentCountry = countryCode;
    this.form.controls['phone_number'].setValidators([Validators.pattern(this.getPhoneNumberRegex(this.currentCountry)), Validators.required]);
    this.selected = countryCode;
    this.form.patchValue({
      country_code: countryCode,
      phone_number: null
    })
  }

  submit(value: AuthRegister) {
    this.checkValidity = true;
    if (this.form.valid && this.passwordMatched && this.serverSideValidations.username) {
      localStorage.setItem('country_code', value.country_code);
      this.disableButton = true;
      this.loadingBar.start();
      for (let key in value) {
        if (value[key] === null) {
          delete value[key];
        }
      }
      this.auth.register(value).pipe(
        tap((res) => {
          this.store.dispatch(fromAuthActions.register());
          of(null).pipe(
            delay(1000), tap(() => this.eventEmitterService.onTopBarTabEmitter()
            )).subscribe();
          this.store.dispatch(fromAuthActions.login({
            user: res.data.user,
            token: res.data.token,
          }));
          localStorage.setItem('verified_number', res.data.user.phone_validated);
          localStorage.setItem('reward_notice', res.data.user.pending_reward);
          this.setSessionStorage();
          this.onCloseDialog();

          this.router.navigate(['/']);
          this.loadingBar.complete();
          this.disableButton = false;
          this.checkValidity = false;
        })
      ).subscribe(
        response => {
          localStorage.removeItem('announcements_pop');
          this.router.navigateByUrl('/');
        }
      );
    }
  }

  toLowerCaseInput(controlName: string, event: Event) {
    this.auth.forceLowerCaseInputControl(this.form, controlName, event);
  }

  numberOnly(event: KeyboardEvent) {
    return this.auth.numberOnly(event);
  }

  onCheckUsernameFormat(username: any) {
    return this.usernameFormatValid = {
      consist: /[a-zA-Z]/.test(username) || (/[0-9]/.test(username) && /[a-zA-Z]/.test(username)),
      special: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(username)
    };
  }

  private setSessionStorage() {
    this.bankHttpService.getAllBanks().subscribe(res => {
      sessionStorage.setItem('all_bank', JSON.stringify(res))
    });
    this.merchantBankHttpService.getMerchantBankDeposits().subscribe(res => {
      sessionStorage.setItem('member_merchant_bank', JSON.stringify(res))
      this.setBankMaintenanceHour();
    });
    this.memberBankHttpService.getMemberBanks().subscribe(res => {
      sessionStorage.setItem('member_bank_accounts', JSON.stringify(res))
    });
  }

  private openDialogBy(componentRef: any) {
    this.dialog.open(componentRef);
  }

  private initializeForm() {
    this.form = this.fb.group({
      username: [
        '',
        [Validators.pattern(`(^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$)|([a-zA-Z])`), Validators.required, Validators.minLength(6), Validators.maxLength(16)]
      ],
      country_code: [
        this.selected
      ],
      phone_number: [
        '',
        [Validators.pattern(this.getPhoneNumberRegex(this.currentCountry)), Validators.required]
      ],
      password: [
        '',
        [Validators.required, Validators.minLength(6)]
      ],
      confirm_password: [
        '',
        [Validators.required]
      ],
      ref: [
        this.ref
      ],
      aff: [
        this.aff
      ],
      agent: [
        this.agent
      ]
    });
  }

  private getPhoneNumberRegex(countryCode: string) {
    return this.dropdownService.regex[countryCode];
  }

  private setRefAgentAff() {
    var ref = JSON.parse(localStorage.getItem('ref'));
    var agent = JSON.parse(localStorage.getItem('agent'));
    var aff = JSON.parse(localStorage.getItem('aff'));

    if (ref !== null) {
      this.ref = ref;
      this.isRefSet = true;
      this.showRef = true;
    }
    else if (agent !== null) {
      this.agent = agent;
      this.showAgent = true;
      this.showRef = false;
    }
    else if (aff !== null) {
      this.aff = aff;
      this.showAff = true;
      this.showRef = false;
    }

  }

  private setBankMaintenanceHour() {
    if (sessionStorage.getItem('member_merchant_bank') !== null) {
      let bank_ids = [];
      JSON.parse(sessionStorage.getItem('member_merchant_bank')).forEach(merchant_banks => {
        if (merchant_banks['bank_id']) {
          bank_ids.push(merchant_banks['bank_id']);
        }
      });
      this.bankMaintenanceHourService.getBankMaintenanceHours(bank_ids).subscribe(res => {
        localStorage.setItem('bank_maintenance_hour', JSON.stringify(res));
      });
    }
  }

  private getAltDomain() {
    let hostname = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');
    // E.g: localhost.com
    // Get localhost.com
    if (hostname.split('.').length > 2) {
      hostname = hostname.substr(hostname.indexOf('.') + 1);
    }

    // First Alternative
    if (
      JSON.stringify(this.supportedCountry[environment.altDomainName]).includes('"' + hostname + '"') ||
      environment.altDomainName.split('|').includes(hostname)
    ) {
      return environment.altDomainName;
    }
    // Second Alternative
    else if (
      JSON.stringify(this.supportedCountry[environment.altDomainNameTwo]).includes('"' + hostname + '"') ||
      environment.altDomainNameTwo.split('|').includes(hostname)
    ) {
      return environment.altDomainNameTwo;
    }
  }

}
